import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=4fc36c0d&scoped=true&"
import script from "./Sms.vue?vue&type=script&lang=js&"
export * from "./Sms.vue?vue&type=script&lang=js&"
import style0 from "./Sms.vue?vue&type=style&index=0&id=4fc36c0d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc36c0d",
  null
  
)

export default component.exports